import React from 'react'
import classnames from 'classnames'
import Card from '@material-ui/core/Card'
import { withStyles } from '@material-ui/core/styles'
import { Row, Col } from 'react-flexbox-grid'
import CardStyles from '../../styles/cards'
import ColumnStyles from '../../styles/components/claim-expenses-columns'
import TitledLabel from '../../controls/TitledLabel'
import { localize } from '../../util/Localizer'
import RBButton from '../../controls/RBButton'
import GenericModal from '../../widgets/common/GenericModal'

class ClaimExpenseLine extends React.Component {
  constructor () {
    super()
    this.state = { showGenericModal: false }
  }

  render () {
    let { expenseDetail, hasCOB, classes = {} } = { ...this.props }
    const colummnCSS = hasCOB ? { ...ColumnStyles.withCOB } : { ...ColumnStyles.withoutCOB }
    return (
      <Card className={ classnames(classes.summaryCard, classes.baseCard) }>
        {this.state.showGenericModal
          ? <GenericModal
            open={this.state.showGenericModal}
            handleOk={() => {
              this.props.onDelete(this.props.index)
              this.setState({ showGenericModal: false })
            }}
            handleClose={() => {
              this.setState({ showGenericModal: false })
            }}
            showOk
            OkButtonText={localize('yesText')}
            CancelButtonText={localize('noText')}
            modal
            message={localize('pages.SubmitAClaim.DeleteWarning')}
          /> : null }
        <Row>
          <Col {...colummnCSS} lg={2}>
            <TitledLabel title='pages.SubmitAClaim.Expenses.ServiceDate' format='date' value={expenseDetail.ServiceDate} />
          </Col>
          <Col {...colummnCSS}>
            <TitledLabel title='pages.SubmitAClaim.Expenses.TypeOfExpense' format='text' value={expenseDetail.ExtendedHealthCareLineInfo.ServiceCodeText} />
          </Col>
          <Col {...colummnCSS}>
            <TitledLabel title='pages.SubmitAClaim.Expenses.PaidAmount' format='currency' value={expenseDetail.ExtendedHealthCareLineInfo.AmountPaid} />
          </Col>
          {hasCOB
            ? <Col {...colummnCSS}>
              <TitledLabel title='pages.SubmitAClaim.Expenses.AmountReceivedFromAllOtherInsurance' format='currency' value={expenseDetail.COBField && expenseDetail.COBField.CobAmount} />
            </Col>
            : null
          }
          <Col {...ColumnStyles.button }>
            <Row end='lg' middle='xs'>
              <Col xs={12}>
                <RBButton variant='outlined' label={localize('pages.SubmitAClaim.Expenses.DeleteButton')} onClick={() => this.setState({ showGenericModal: true })} className={classnames(classes.margin)} />
                <RBButton variant='outlined' label={localize('pages.SubmitAClaim.Expenses.EditButton')} onClick={() => this.props.onEdit(this.props.index)} className={classnames(classes.margin)} />
              </Col>
            </Row>
          </Col>
        </Row>
      </Card>
    )
  }
}

const styles = {
  ...CardStyles,
  margin: {
    margin: 5
  }
}

export default withStyles(styles)(ClaimExpenseLine)



// WEBPACK FOOTER //
// ./src/widgets/SubmitAClaim/ClaimExpenseLine.js